import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=8bac66fc&scoped=true&"
import script from "./AppMenu.vue?vue&type=script&lang=ts&"
export * from "./AppMenu.vue?vue&type=script&lang=ts&"
import style0 from "./appMenu.scss?vue&type=style&index=0&id=8bac66fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bac66fc",
  null
  
)

export default component.exports